// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnterpriseCoordinatorAccountServiceModelsAccountContactUpsearchModel {
    static getAttributeTypeMap() {
        return EnterpriseCoordinatorAccountServiceModelsAccountContactUpsearchModel.attributeTypeMap;
    }
}
EnterpriseCoordinatorAccountServiceModelsAccountContactUpsearchModel.discriminator = undefined;
EnterpriseCoordinatorAccountServiceModelsAccountContactUpsearchModel.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "number"
    },
    {
        "name": "roleType",
        "baseName": "roleType",
        "type": "RoleType"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "phoneNumber",
        "baseName": "phoneNumber",
        "type": "string"
    },
    {
        "name": "altPhoneNumber",
        "baseName": "altPhoneNumber",
        "type": "string"
    }
];
//# sourceMappingURL=enterpriseCoordinatorAccountServiceModelsAccountContactUpsearchModel.js.map